import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-3 dark:border-amber-900/50 dark:bg-amber-950/20"
}
const _hoisted_3 = { class: "mt-0.5 text-xs text-amber-800 dark:text-amber-300" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 pb-2 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_5 = { class: "relative flex-1 max-w-sm" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "flex flex-wrap items-center gap-1.5 pb-1" }
const _hoisted_8 = { class: "px-1.5 py-0.2 rounded-full text-[10px] font-bold bg-white/20" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "py-12 flex flex-col items-center justify-center space-y-3"
}
const _hoisted_11 = { class: "flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "text-xs text-sky-700 dark:text-sky-300" }
const _hoisted_14 = {
  key: 0,
  class: "pointer-events-none absolute inset-3 z-10 flex items-center justify-center rounded-xl border-2 border-dashed border-amber-400 bg-amber-100/85 px-4 py-5 text-center text-sm font-bold text-amber-800 shadow-sm backdrop-blur-[1px] dark:border-amber-500 dark:bg-amber-950/75 dark:text-amber-200"
}
const _hoisted_15 = { class: "min-w-0 max-w-full flex-1" }
const _hoisted_16 = { class: "truncate text-sm font-semibold text-gray-800 dark:text-gray-200" }
const _hoisted_17 = { class: "max-w-full break-all text-xs leading-4 text-gray-500 dark:text-gray-400" }
const _hoisted_18 = { class: "flex w-full items-center justify-end gap-2 sm:w-auto" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 3,
  class: "py-12 px-4 text-center rounded-2xl bg-gray-50 dark:bg-gray-800/40 border border-dashed border-gray-300 dark:border-gray-700 space-y-3"
}
const _hoisted_22 = { class: "w-12 h-12 mx-auto rounded-2xl bg-gray-100 dark:bg-gray-700/60 text-gray-400 flex items-center justify-center" }
const _hoisted_23 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-1 max-w-sm mx-auto" }
const _hoisted_24 = { class: "pt-1" }
const _hoisted_25 = ["draggable", "onDragstart"]
const _hoisted_26 = { class: "flex flex-col sm:flex-row sm:items-start justify-between gap-3" }
const _hoisted_27 = { class: "flex items-start gap-3 min-w-0" }
const _hoisted_28 = { class: "p-2.5 rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 flex-shrink-0 mt-0.5" }
const _hoisted_29 = { class: "min-w-0 space-y-1" }
const _hoisted_30 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "flex flex-wrap items-center gap-x-2.5 gap-y-1 text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-secondary dark:text-secondary-dark-text italic pt-0.5"
}
const _hoisted_35 = { class: "flex flex-wrap sm:flex-col sm:items-end gap-2 flex-shrink-0" }
const _hoisted_36 = ["title"]
const _hoisted_37 = { class: "text-gray-600 dark:text-gray-400 font-mono" }
const _hoisted_38 = {
  key: 0,
  class: "text-[10px] font-bold text-amber-600 dark:text-amber-400 ml-0.5"
}
const _hoisted_39 = {
  key: 1,
  class: "text-[11px] text-gray-400 dark:text-gray-500"
}
const _hoisted_40 = { class: "pt-2.5 border-t border-gray-100 dark:border-gray-700/70 flex flex-wrap items-center justify-between gap-2" }
const _hoisted_41 = { class: "text-[11px] text-gray-400 dark:text-gray-500" }
const _hoisted_42 = { class: "flex flex-wrap items-center gap-1.5 sm:gap-2" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_50 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "flex items-center justify-end gap-2 w-full" }
const _hoisted_53 = { class: "space-y-4" }
const _hoisted_54 = {
  key: 0,
  class: "py-16 flex flex-col items-center justify-center space-y-3"
}
const _hoisted_55 = {
  key: 1,
  class: "w-full"
}
const _hoisted_56 = {
  key: 0,
  class: "rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 flex justify-center items-center min-h-[400px] max-h-[600px]"
}
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = {
  key: 1,
  class: "w-full"
}
const _hoisted_59 = {
  key: 2,
  class: "rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 flex justify-center items-center min-h-[400px]"
}
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 3,
  class: "rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-900 p-8 text-center space-y-3"
}
const _hoisted_62 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_63 = { class: "flex items-center justify-between w-full" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_66 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_67 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_68 = { class: "flex items-center justify-end gap-2 w-full" }
const _hoisted_69 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_70 = { class: "min-w-0 max-w-full break-words text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_71 = { class: "break-all font-bold text-gray-900 dark:text-white" }
const _hoisted_72 = { class: "flex items-center justify-end gap-2 w-full" }
const _hoisted_73 = { class: "space-y-3" }
const _hoisted_74 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_75 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_76 = { class: "flex items-center justify-end gap-2 w-full" }
const _hoisted_77 = { class: "flex items-center justify-between w-full" }
const _hoisted_78 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_79 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "font-bold text-sky-700 dark:text-sky-300" }

import { ref, computed, watch } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import DocxViewer from '@/components/common/DocxViewer.vue'
import { employeeDocumentService } from '@/services/employeeDocumentService'
import formerEmployeeService from '@/services/formerEmployeeService'
import { useToastService } from '@/services/toast'
import type { employee } from '@/types/employee'
import type { FormerEmployeeFile } from '@/types/formerEmployee'
import {
  DOCUMENT_CATEGORIES,
  type DocumentCategory,
  type EmployeeDocument,
  documentNeedsAttention,
  isDocumentExpired,
  isDocumentExpiringSoon,
} from '@/types/employeeDocument'
import {
  FolderLock,
  Search,
  UploadCloud,
  FolderOpen,
  FileText,
  ImageIcon,
  Paperclip,
  Eye,
  Download,
  Edit3,
  RefreshCw,
  Trash2,
  Clock,
  AlertTriangle,
  Archive,
  Undo2,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewStaffDocuments',
  props: {
    isVisible: { type: Boolean },
    employee: {},
    initialCategory: {}
  },
  emits: ["close", "upload", "updated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const toast = useToastService()

const documents = ref<EmployeeDocument[]>([])
const formerFiles = ref<FormerEmployeeFile[]>([])
const isLoading = ref(false)
const isLoadingFormerFiles = ref(false)
const isArchiveDragOver = ref(false)
const archiveDragDepth = ref(0)
const draggedDocument = ref<EmployeeDocument | null>(null)
const archivingDocumentId = ref<number | null>(null)
const isArchiveConfirmVisible = ref(false)
const documentToArchive = ref<EmployeeDocument | null>(null)
const isRestoreConfirmVisible = ref(false)
const fileToRestore = ref<FormerEmployeeFile | null>(null)
const isRestoring = ref(false)
const searchQuery = ref('')
const selectedCategory = ref<string>('all')

// Edit state
const isEditModalVisible = ref(false)
const selectedDocForEdit = ref<EmployeeDocument | null>(null)
const isSavingEdit = ref(false)
const editForm = ref({
  document_name: '',
  document_category: 'other' as DocumentCategory,
  notes: '',
  expiry_date: '',
})

// Replace state
const replaceFileInputRef = ref<HTMLInputElement | null>(null)
const docToReplace = ref<EmployeeDocument | null>(null)
const replacingDocumentId = ref<number | null>(null)

// Preview state
const isPreviewModalVisible = ref(false)
const previewDoc = ref<EmployeeDocument | null>(null)
const previewBlobUrl = ref<string | null>(null)
const previewBlob = ref<Blob | null>(null)
const previewMimeType = ref<string>('application/pdf')
const isLoadingPreview = ref(false)

const isPdfPreview = computed(() => {
  if (!previewDoc.value) return false
  const ext = previewDoc.value.file_name.toLowerCase()
  return ext.endsWith('.pdf') || previewMimeType.value === 'application/pdf'
})

const isImagePreview = computed(() => {
  if (!previewDoc.value) return false
  const ext = previewDoc.value.file_name.toLowerCase()
  return (
    ext.endsWith('.jpg') ||
    ext.endsWith('.jpeg') ||
    ext.endsWith('.png') ||
    ext.endsWith('.webp') ||
    ext.endsWith('.gif') ||
    previewMimeType.value.startsWith('image/')
  )
})

const isDocxPreview = computed(() => {
  if (!previewDoc.value) return false
  const ext = previewDoc.value.file_name.toLowerCase()
  return (
    ext.endsWith('.docx') ||
    ext.endsWith('.doc') ||
    previewMimeType.value === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    previewMimeType.value === 'application/msword'
  )
})

// Delete state
const isDeleteModalVisible = ref(false)
const docToDelete = ref<EmployeeDocument | null>(null)
const isDeleting = ref(false)

// Fetch documents on open
watch(
  () => props.isVisible,
  (visible) => {
    if (visible) {
      selectedCategory.value = props.initialCategory || 'all'
    }
    if (visible && props.employee?.user_id) {
      fetchDocuments()
    }
    if (visible && props.employee?.former_employee?.former_employee_id) {
      fetchFormerFiles()
    }
    if (!visible) {
      formerFiles.value = []
    }
  },
  { immediate: true }
)

watch(
  () => props.initialCategory,
  (newCat) => {
    if (props.isVisible && newCat) {
      selectedCategory.value = newCat
    }
  }
)

const fetchDocuments = async () => {
  if (!props.employee?.user_id) return

  isLoading.value = true
  try {
    const list = await employeeDocumentService.getDocuments(props.employee.user_id)
    documents.value = list
    emit('updated', list.length)
  } catch (err) {
    toast.error('Failed to load employee documents.')
  } finally {
    isLoading.value = false
  }
}

const fetchFormerFiles = async () => {
  const formerEmployeeId = props.employee?.former_employee?.former_employee_id
  if (!formerEmployeeId) return

  isLoadingFormerFiles.value = true
  try {
    const record = await formerEmployeeService.getFormerEmployee(formerEmployeeId)
    formerFiles.value = record.files || []
  } catch (err) {
    formerFiles.value = []
    toast.error('Failed to load archived former-employee files.')
  } finally {
    isLoadingFormerFiles.value = false
  }
}

// Category counts
const categoryCounts = computed(() => {
  const counts: Record<string, number> = {}
  documents.value.forEach(doc => {
    counts[doc.document_category] = (counts[doc.document_category] || 0) + 1
  })
  return counts
})

// Expired documents count
const expiredCount = computed(() => {
  return documents.value.filter(d => isDocumentExpired(d.expiry_date)).length
})

// Expiring soon documents count (< 1 year before expiry)
const expiringSoonCount = computed(() => {
  return documents.value.filter(d => isDocumentExpiringSoon(d.expiry_date)).length
})

// Documents needing attention (expired or < 1 year before expiry)
const expiredOrExpiringCount = computed(() => {
  return documents.value.filter(d => documentNeedsAttention(d)).length
})

// Filtered list
const filteredDocuments = computed(() => {
  let list = documents.value

  if (selectedCategory.value === 'expired') {
    list = list.filter(d => isDocumentExpired(d.expiry_date))
  } else if (selectedCategory.value === 'expiring_soon') {
    list = list.filter(d => isDocumentExpiringSoon(d.expiry_date))
  } else if (selectedCategory.value === 'needs_attention') {
    list = list.filter(d => documentNeedsAttention(d))
  } else if (selectedCategory.value !== 'all') {
    list = list.filter(d => d.document_category === selectedCategory.value)
  }

  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase().trim()
    list = list.filter(d =>
      d.document_name.toLowerCase().includes(q) ||
      d.file_name.toLowerCase().includes(q) ||
      (d.notes && d.notes.toLowerCase().includes(q))
    )
  }

  return list
})

const filteredFormerFiles = computed(() => {
  let list = formerFiles.value

  if (['needs_attention', 'expired', 'expiring_soon'].includes(selectedCategory.value)) {
    return []
  } else if (selectedCategory.value !== 'all') {
    list = list.filter(file => file.file_category === selectedCategory.value)
  }

  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase().trim()
    list = list.filter(file =>
      file.file_name.toLowerCase().includes(q) ||
      (file.file_label && file.file_label.toLowerCase().includes(q))
    )
  }

  return list
})

const getCategoryLabel = (category: string) => {
  const item = DOCUMENT_CATEGORIES.find(c => c.value === category)
  return item ? item.label : category
}

const getCategoryBadgeClass = (category: string) => {
  const item = DOCUMENT_CATEGORIES.find(c => c.value === category)
  return item ? item.badgeClass : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
}

const formatFileSize = (bytes: number | null) => {
  if (!bytes) return '0 B'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return 'N/A'
  try {
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return dateStr
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return dateStr
  }
}

const isPdf = (doc: EmployeeDocument) => doc.file_type === 'application/pdf' || doc.file_name.endsWith('.pdf')
const isDoc = (doc: EmployeeDocument) => doc.file_name.endsWith('.doc') || doc.file_name.endsWith('.docx')
const isImage = (doc: EmployeeDocument) => (doc.file_type && doc.file_type.startsWith('image/')) || /\.(jpg|jpeg|png)$/i.test(doc.file_name)

// Actions
const downloadDocument = async (doc: EmployeeDocument) => {
  if (!props.employee?.user_id) return
  try {
    await employeeDocumentService.downloadDocument(props.employee.user_id, doc.document_id, doc.file_name)
    toast.success(`Downloading ${doc.file_name}`)
  } catch (err) {
    toast.error('Failed to download document.')
  }
}

const downloadFormerFile = async (file: FormerEmployeeFile) => {
  const formerEmployeeId = props.employee?.former_employee?.former_employee_id
  if (!formerEmployeeId) return

  try {
    await formerEmployeeService.downloadFile(formerEmployeeId, file.file_id, file.file_name)
    toast.success(`Downloading ${file.file_name}`)
  } catch (err) {
    toast.error('Failed to download archived file.')
  }
}

const requestRestoreFormerFile = (file: FormerEmployeeFile) => {
  if (!props.employee?.former_employee?.former_employee_id || isRestoring.value) return
  fileToRestore.value = file
  isRestoreConfirmVisible.value = true
}

const closeRestoreConfirmation = () => {
  if (isRestoring.value) return
  isRestoreConfirmVisible.value = false
  fileToRestore.value = null
}

const restoreFormerFile = async () => {
  const formerEmployeeId = props.employee?.former_employee?.former_employee_id
  const file = fileToRestore.value
  if (!formerEmployeeId || !file || isRestoring.value) return

  isRestoring.value = true
  try {
    const restoredDocument = await formerEmployeeService.restoreFile(formerEmployeeId, file.file_id)
    formerFiles.value = formerFiles.value.filter(item => item.file_id !== file.file_id)
    documents.value.unshift(restoredDocument)
    emit('updated', documents.value.length)
    toast.success('File restored', `${file.file_name} was moved to current documents.`)
    isRestoreConfirmVisible.value = false
    fileToRestore.value = null
  } catch (error: any) {
    toast.error('Restore failed', error?.response?.data?.message || 'The archived file could not be restored.')
  } finally {
    isRestoring.value = false
  }
}

const startDocumentDrag = (document: EmployeeDocument) => {
  if (props.employee?.is_former_employee) {
    draggedDocument.value = document
    archiveDragDepth.value = 0
  }
}

const endDocumentDrag = () => {
  draggedDocument.value = null
  archiveDragDepth.value = 0
  isArchiveDragOver.value = false
}

const handleArchiveDragEnter = () => {
  if (!draggedDocument.value) return
  archiveDragDepth.value += 1
  isArchiveDragOver.value = true
}

const handleArchiveDragLeave = () => {
  archiveDragDepth.value = Math.max(0, archiveDragDepth.value - 1)
  if (archiveDragDepth.value === 0) {
    isArchiveDragOver.value = false
  }
}

const handleArchiveDrop = () => {
  isArchiveDragOver.value = false
  archiveDragDepth.value = 0
  if (draggedDocument.value) {
    requestArchiveDocument(draggedDocument.value)
  }
  draggedDocument.value = null
}

const requestArchiveDocument = (document: EmployeeDocument) => {
  if (!props.employee?.user_id || !props.employee.is_former_employee || archivingDocumentId.value) return
  documentToArchive.value = document
  isArchiveConfirmVisible.value = true
}

const closeArchiveConfirmation = () => {
  if (archivingDocumentId.value) return
  isArchiveConfirmVisible.value = false
  documentToArchive.value = null
}

const archiveDocument = async () => {
  const document = documentToArchive.value
  if (!document || !props.employee?.user_id || !props.employee.is_former_employee || archivingDocumentId.value) return

  archivingDocumentId.value = document.document_id
  try {
    const archivedFile = await employeeDocumentService.archiveDocument(props.employee.user_id, document.document_id)
    documents.value = documents.value.filter(item => item.document_id !== document.document_id)
    formerFiles.value.unshift(archivedFile)
    emit('updated', documents.value.length)
    toast.success('Document archived', `${document.document_name} was moved to Former Employee Records.`)
    isArchiveConfirmVisible.value = false
    documentToArchive.value = null
  } catch (error: any) {
    toast.error('Archive failed', error?.response?.data?.message || 'The document could not be moved to the archive.')
  } finally {
    archivingDocumentId.value = null
  }
}

const previewDocument = async (doc: EmployeeDocument) => {
  if (!props.employee?.user_id) return
  previewDoc.value = doc
  isPreviewModalVisible.value = true
  isLoadingPreview.value = true
  previewBlobUrl.value = null
  previewBlob.value = null

  try {
    const { url, mimeType, blob } = await employeeDocumentService.getPreviewBlobUrl(props.employee.user_id, doc.document_id)
    previewBlobUrl.value = url
    previewBlob.value = blob
    previewMimeType.value = mimeType
  } catch (err) {
    toast.error('Could not load inline preview for this file.')
  } finally {
    isLoadingPreview.value = false
  }
}

const closePreviewModal = () => {
  isPreviewModalVisible.value = false
  if (previewBlobUrl.value) {
    window.URL.revokeObjectURL(previewBlobUrl.value)
    previewBlobUrl.value = null
  }
  previewBlob.value = null
  previewDoc.value = null
}

const openEditModal = (doc: EmployeeDocument) => {
  selectedDocForEdit.value = doc
  editForm.value = {
    document_name: doc.document_name,
    document_category: doc.document_category,
    notes: doc.notes || '',
    expiry_date: doc.expiry_date || '',
  }
  isEditModalVisible.value = true
}

const handleSaveEdit = async () => {
  if (!props.employee?.user_id || !selectedDocForEdit.value) return

  isSavingEdit.value = true
  try {
    const updated = await employeeDocumentService.updateDocument(
      props.employee.user_id,
      selectedDocForEdit.value.document_id,
      {
        document_name: editForm.value.document_name,
        document_category: editForm.value.document_category,
        notes: editForm.value.notes || null,
        expiry_date: editForm.value.expiry_date || null,
      }
    )

    // Update locally
    const idx = documents.value.findIndex(d => d.document_id === updated.document_id)
    if (idx !== -1) {
      documents.value[idx] = {
        ...documents.value[idx],
        ...updated,
      }
    }

    toast.success('Document updated successfully.')
    isEditModalVisible.value = false
  } catch (err) {
    toast.error('Failed to update document details.')
  } finally {
    isSavingEdit.value = false
  }
}

const triggerReplaceInput = (doc: EmployeeDocument) => {
  docToReplace.value = doc
  replaceFileInputRef.value?.click()
}

const handleReplaceFileSelected = async (e: Event) => {
  const target = e.target as HTMLInputElement
  if (!target.files || target.files.length === 0 || !docToReplace.value || !props.employee?.user_id) return

  const file = target.files[0]
  if (file.size > 32 * 1024 * 1024) {
    toast.error('File Too Large', `"${file.name}" exceeds the 32MB size limit.`)
    target.value = ''
    return
  }

  const formData = new FormData()
  formData.append('document', file)
  replacingDocumentId.value = docToReplace.value.document_id

  try {
    const updated = await employeeDocumentService.replaceDocument(
      props.employee.user_id,
      docToReplace.value.document_id,
      formData
    )

    const idx = documents.value.findIndex(d => d.document_id === updated.document_id)
    if (idx !== -1) {
      documents.value[idx] = {
        ...documents.value[idx],
        ...updated,
      }
    }

    toast.success(`File replaced with ${file.name}`)
  } catch (err) {
    toast.error('Failed to replace document file.')
  } finally {
    if (replaceFileInputRef.value) {
      replaceFileInputRef.value.value = ''
    }
    docToReplace.value = null
    replacingDocumentId.value = null
  }
}

const confirmDeleteDocument = (doc: EmployeeDocument) => {
  docToDelete.value = doc
  isDeleteModalVisible.value = true
}

const handleDeleteDocument = async () => {
  if (!props.employee?.user_id || !docToDelete.value) return

  isDeleting.value = true
  try {
    const deletedId = docToDelete.value.document_id
    await employeeDocumentService.deleteDocument(props.employee.user_id, deletedId)
    documents.value = documents.value.filter(d => d.document_id !== deletedId)
    emit('updated', documents.value.length)
    toast.success('Document deleted successfully.')
    isDeleteModalVisible.value = false
  } catch (err) {
    toast.error('Failed to delete document.')
  } finally {
    isDeleting.value = false
    docToDelete.value = null
  }
}

const closeModal = () => {
  emit('close')
}

// Expose refresh for parent when upload succeeds
__expose({
  fetchDocuments
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Staff Documents & Credentials",
    subtitle: _ctx.employee ? `${_ctx.employee.first_name} ${_ctx.employee.last_name}'s credentials, certificates & files` : 'Manage employee documents',
    icon: _unref(FolderLock),
    size: "4xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _cache[52] || (_cache[52] = _createTextVNode(" Total: ", -1)),
          _createElementVNode("span", _hoisted_79, _toDisplayString(documents.value.length), 1),
          _cache[53] || (_cache[53] = _createTextVNode(" current document(s) ", -1)),
          (formerFiles.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                _cache[50] || (_cache[50] = _createTextVNode(" · ", -1)),
                _createElementVNode("span", _hoisted_81, _toDisplayString(formerFiles.value.length), 1),
                _cache[51] || (_cache[51] = _createTextVNode(" archived file(s)", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BaseButton, {
          text: "Close",
          variant: "primary",
          size: "sm",
          onClick: closeModal
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.employee?.is_former_employee)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Archive), { class: "mt-0.5 h-4 w-4 flex-shrink-0 text-amber-600 dark:text-amber-400" }),
              _createElementVNode("div", null, [
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-xs font-bold text-amber-900 dark:text-amber-200" }, "Former Employee Record Linked", -1)),
                _createElementVNode("p", _hoisted_3, " This account is linked to an archived former-employee record" + _toDisplayString(_ctx.employee.former_employee?.date_separated ? ` separated on ${_ctx.employee.former_employee.date_separated}` : '') + _toDisplayString(_ctx.employee.former_employee?.reason_for_leaving ? ` due to ${_ctx.employee.former_employee.reason_for_leaving.toLowerCase()}` : '') + ". Documents shown below are current employee documents; archived former-employee files are maintained separately. ", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Search), { class: "w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              placeholder: "Search documents by name or file...",
              class: "w-full pl-9 pr-3.5 py-2 text-xs sm:text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseButton, {
              text: "Upload Documents",
              variant: "primary",
              size: "sm",
              icon: _unref(UploadCloud),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('upload', _ctx.employee)))
            }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedCategory.value = 'all')),
            class: _normalizeClass([
            'px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-150 flex items-center gap-1.5',
            selectedCategory.value === 'all'
              ? 'bg-secondary text-white shadow-sm'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          ])
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "All Documents", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(documents.value.length + formerFiles.value.length), 1)
          ], 2),
          (expiredCount.value > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedCategory.value = selectedCategory.value === 'expired' ? 'all' : 'expired')),
                class: _normalizeClass([
            'px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-150 flex items-center gap-1.5',
            selectedCategory.value === 'expired'
              ? 'bg-red-600 text-white shadow-sm'
              : 'bg-red-50 dark:bg-red-950/30 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/40 border border-red-200 dark:border-red-800'
          ])
              }, [
                _createVNode(_unref(AlertTriangle), { class: "w-3.5 h-3.5" }),
                _cache[21] || (_cache[21] = _createElementVNode("span", null, "Expired", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px] font-bold", selectedCategory.value === 'expired' ? 'bg-white/20 text-white' : 'bg-red-200 dark:bg-red-800 text-red-900 dark:text-red-100'])
                }, _toDisplayString(expiredCount.value), 3)
              ], 2))
            : _createCommentVNode("", true),
          (expiringSoonCount.value > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedCategory.value = selectedCategory.value === 'expiring_soon' ? 'all' : 'expiring_soon')),
                class: _normalizeClass([
            'px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-150 flex items-center gap-1.5',
            selectedCategory.value === 'expiring_soon'
              ? 'bg-amber-500 text-white shadow-sm'
              : 'bg-amber-50 dark:bg-amber-950/30 text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 border border-amber-200 dark:border-amber-800'
          ])
              }, [
                _createVNode(_unref(Clock), { class: "w-3.5 h-3.5" }),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "Expiring Soon", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px] font-bold", selectedCategory.value === 'expiring_soon' ? 'bg-white/20 text-white' : 'bg-amber-200 dark:bg-amber-800 text-amber-900 dark:text-amber-100'])
                }, _toDisplayString(expiringSoonCount.value), 3)
              ], 2))
            : _createCommentVNode("", true),
          (expiredCount.value > 0 && expiringSoonCount.value > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedCategory.value = selectedCategory.value === 'needs_attention' ? 'all' : 'needs_attention')),
                class: _normalizeClass([
            'px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-150 flex items-center gap-1.5',
            selectedCategory.value === 'needs_attention'
              ? 'bg-amber-600 text-white shadow-sm'
              : 'bg-amber-50/60 dark:bg-amber-950/20 text-amber-800 dark:text-amber-200 hover:bg-amber-100 dark:hover:bg-amber-900/30 border border-amber-300/80 dark:border-amber-800/60'
          ]),
                title: "View both expired and expiring soon documents"
              }, [
                _createVNode(_unref(Clock), { class: "w-3.5 h-3.5" }),
                _cache[23] || (_cache[23] = _createElementVNode("span", null, "All Needs Attention", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px] font-bold", selectedCategory.value === 'needs_attention' ? 'bg-white/20 text-white' : 'bg-amber-200 dark:bg-amber-800 text-amber-900 dark:text-amber-100'])
                }, _toDisplayString(expiredOrExpiringCount.value), 3)
              ], 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOCUMENT_CATEGORIES), (cat) => {
            return (_openBlock(), _createElementBlock("button", {
              key: cat.value,
              type: "button",
              onClick: ($event: any) => (selectedCategory.value = cat.value),
              class: _normalizeClass([
            'px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all duration-150 flex items-center gap-1.5',
            selectedCategory.value === cat.value
              ? 'bg-secondary text-white shadow-sm'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
          ])
            }, [
              _createElementVNode("span", null, _toDisplayString(cat.label), 1),
              (categoryCounts.value[cat.value])
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["px-1.5 py-0.2 rounded-full text-[10px] font-bold", selectedCategory.value === cat.value ? 'bg-white/20' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200'])
                  }, _toDisplayString(categoryCounts.value[cat.value]), 3))
                : _createCommentVNode("", true)
            ], 10, _hoisted_9))
          }), 128))
        ]),
        (isLoading.value || isLoadingFormerFiles.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("div", { class: "w-8 h-8 border-3 border-secondary border-t-transparent rounded-full animate-spin" }, null, -1),
              _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Loading documents...", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!isLoading.value && !isLoadingFormerFiles.value && _ctx.employee?.is_former_employee)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["relative space-y-3 rounded-2xl border-2 p-4 transition", isArchiveDragOver.value
          ? 'border-amber-500 bg-amber-50 dark:border-amber-400 dark:bg-amber-950/30'
          : 'border-sky-200 bg-sky-50/50 dark:border-sky-900/50 dark:bg-sky-950/20']),
              onDragenter: _withModifiers(handleArchiveDragEnter, ["prevent"]),
              onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (isArchiveDragOver.value = true), ["prevent"])),
              onDragleave: _withModifiers(handleArchiveDragLeave, ["prevent"]),
              onDrop: _withModifiers(handleArchiveDrop, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(Archive), { class: "h-4 w-4 text-sky-600 dark:text-sky-400" }),
                  _createElementVNode("div", null, [
                    _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "text-sm font-bold text-sky-900 dark:text-sky-200" }, "Former Employee Archive", -1)),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(filteredFormerFiles.value.length) + " archived file(s), separate from current documents", 1)
                  ])
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "whitespace-nowrap rounded-full border border-sky-200 bg-white px-2.5 py-1.5 text-[10px] font-bold text-sky-700 dark:border-sky-800 dark:bg-sky-950/40 dark:text-sky-300" }, "Former Employee Record", -1))
              ]),
              (isArchiveDragOver.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Drop document here to move it to the archive "))
                : _createCommentVNode("", true),
              (filteredFormerFiles.value.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["space-y-2", { 'opacity-30': isArchiveDragOver.value }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFormerFiles.value, (file) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `former-${file.file_id}`,
                        class: "flex max-w-full flex-wrap items-start gap-3 overflow-hidden rounded-xl border border-sky-100 bg-white p-3 dark:border-sky-900/50 dark:bg-gray-800"
                      }, [
                        _createVNode(_unref(FileText), { class: "h-5 w-5 flex-shrink-0 text-sky-600 dark:text-sky-400" }),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(file.file_label || file.file_name), 1),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(file.file_name) + " · " + _toDisplayString(formatFileSize(file.file_size)) + " · " + _toDisplayString(getCategoryLabel(file.file_category || 'other')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center gap-1.5 rounded-lg border border-emerald-200 bg-emerald-50 px-2.5 py-1.5 text-xs font-semibold text-emerald-700 transition hover:bg-emerald-100 dark:border-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-300",
                            title: "Download archived file",
                            onClick: ($event: any) => (downloadFormerFile(file))
                          }, [
                            _createVNode(_unref(Download), { class: "h-3.5 w-3.5" }),
                            _cache[27] || (_cache[27] = _createTextVNode(" Download ", -1))
                          ], 8, _hoisted_19),
                          _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-1.5 text-xs font-semibold text-amber-700 transition hover:bg-amber-100 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-300",
                            title: "Move back to current documents",
                            onClick: ($event: any) => (requestRestoreFormerFile(file))
                          }, [
                            _createVNode(_unref(Undo2), { class: "h-3.5 w-3.5" }),
                            _cache[28] || (_cache[28] = _createTextVNode(" Restore ", -1))
                          ], 8, _hoisted_20)
                        ])
                      ]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true),
              (!filteredFormerFiles.value.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["rounded-xl border border-dashed border-sky-200 px-4 py-5 text-center text-xs text-sky-700 dark:border-sky-800 dark:text-sky-300", { 'opacity-30': isArchiveDragOver.value }])
                  }, " Drag a current document here to add the first archived file. ", 2))
                : _createCommentVNode("", true)
            ], 34))
          : _createCommentVNode("", true),
        (!isLoading.value && !isLoadingFormerFiles.value && filteredDocuments.value.length === 0 && filteredFormerFiles.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(FolderOpen), { class: "w-6 h-6" })
              ]),
              _createElementVNode("div", null, [
                _cache[29] || (_cache[29] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-800 dark:text-gray-200" }, "No documents found", -1)),
                _createElementVNode("p", _hoisted_23, _toDisplayString(searchQuery.value ? 'No documents match your search query.' : 'There are no files uploaded in this category for this staff member.'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(BaseButton, {
                  text: "Upload Document",
                  variant: "outline",
                  size: "sm",
                  icon: _unref(UploadCloud),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('upload', _ctx.employee)))
                }, null, 8, ["icon"])
              ])
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && !isLoadingFormerFiles.value && filteredDocuments.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["space-y-3 max-h-[500px] overflow-y-auto pr-1 transition-opacity", { 'opacity-50': isArchiveDragOver.value }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDocuments.value, (doc) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: doc.document_id,
                  draggable: Boolean(_ctx.employee?.is_former_employee),
                  onDragstart: ($event: any) => (startDocumentDrag(doc)),
                  onDragend: endDocumentDrag,
                  class: _normalizeClass([{ 'cursor-grab active:cursor-grabbing': _ctx.employee?.is_former_employee }, "p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-xs hover:border-secondary/40 transition duration-150 space-y-3"])
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        (isPdf(doc))
                          ? (_openBlock(), _createBlock(_unref(FileText), {
                              key: 0,
                              class: "w-5 h-5 text-red-500"
                            }))
                          : (isDoc(doc))
                            ? (_openBlock(), _createBlock(_unref(FileText), {
                                key: 1,
                                class: "w-5 h-5 text-blue-500"
                              }))
                            : (isImage(doc))
                              ? (_openBlock(), _createBlock(_unref(ImageIcon), {
                                  key: 2,
                                  class: "w-5 h-5 text-emerald-500"
                                }))
                              : (_openBlock(), _createBlock(_unref(Paperclip), {
                                  key: 3,
                                  class: "w-5 h-5 text-gray-500"
                                }))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("h4", {
                            class: "text-sm font-bold text-gray-900 dark:text-white break-words",
                            title: doc.document_name
                          }, _toDisplayString(doc.document_name), 9, _hoisted_31),
                          _createElementVNode("span", {
                            class: _normalizeClass([
                      'px-2 py-0.5 rounded-md text-[10px] font-bold border sm:hidden',
                      getCategoryBadgeClass(doc.document_category)
                    ])
                          }, _toDisplayString(getCategoryLabel(doc.document_category)), 3)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", {
                            class: "font-medium text-gray-700 dark:text-gray-300 truncate max-w-[200px]",
                            title: doc.file_name
                          }, _toDisplayString(doc.file_name), 9, _hoisted_33),
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "•", -1)),
                          _createElementVNode("span", null, _toDisplayString(formatFileSize(doc.file_size)), 1),
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "•", -1)),
                          _createElementVNode("span", null, "Uploaded by " + _toDisplayString(doc.uploader_name || 'Administrator') + " on " + _toDisplayString(formatDate(doc.created_at)), 1)
                        ]),
                        (doc.notes)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Note: " + _toDisplayString(doc.notes), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'hidden sm:inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold border',
                  getCategoryBadgeClass(doc.document_category)
                ])
                      }, _toDisplayString(getCategoryLabel(doc.document_category)), 3),
                      (doc.expiry_date)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-lg text-xs font-medium bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-700",
                            title: doc.is_expired || _unref(isDocumentExpired)(doc.expiry_date) ? 'Document has expired' : doc.is_expiring_soon || _unref(isDocumentExpiringSoon)(doc.expiry_date) ? 'Expiry Notice: Document expires in less than 1 year' : 'Valid and active'
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                    'w-2 h-2 rounded-full',
                    doc.is_expired || _unref(isDocumentExpired)(doc.expiry_date)
                      ? 'bg-red-500'
                      : doc.is_expiring_soon || _unref(isDocumentExpiringSoon)(doc.expiry_date)
                        ? 'bg-amber-500'
                        : 'bg-green-500'
                  ])
                            }, null, 2),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                    'font-semibold',
                    doc.is_expired || _unref(isDocumentExpired)(doc.expiry_date)
                      ? 'text-red-600 dark:text-red-400'
                      : doc.is_expiring_soon || _unref(isDocumentExpiringSoon)(doc.expiry_date)
                        ? 'text-amber-600 dark:text-amber-400'
                        : 'text-gray-700 dark:text-gray-300'
                  ])
                            }, _toDisplayString(doc.is_expired || _unref(isDocumentExpired)(doc.expiry_date) ? 'Expired' : 'Expires') + ": ", 3),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(formatDate(doc.expiry_date)), 1),
                            (!doc.is_expired && !_unref(isDocumentExpired)(doc.expiry_date) && (doc.is_expiring_soon || _unref(isDocumentExpiringSoon)(doc.expiry_date)))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, " (< 1 yr) "))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_36))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, " No expiration date "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, " ID: #" + _toDisplayString(doc.document_id), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (previewDocument(doc)),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium text-secondary hover:bg-secondary/10 dark:text-secondary-dark-text dark:hover:bg-secondary-dark/20 border border-secondary/20 transition",
                        title: "Preview Document Inline"
                      }, [
                        _createVNode(_unref(Eye), { class: "w-3.5 h-3.5" }),
                        _cache[32] || (_cache[32] = _createElementVNode("span", null, "Preview", -1))
                      ], 8, _hoisted_43),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (downloadDocument(doc)),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 dark:text-emerald-300 dark:bg-emerald-950/40 dark:hover:bg-emerald-900/40 border border-emerald-200 dark:border-emerald-800 transition",
                        title: "Download Document"
                      }, [
                        _createVNode(_unref(Download), { class: "w-3.5 h-3.5" }),
                        _cache[33] || (_cache[33] = _createElementVNode("span", null, "Download", -1))
                      ], 8, _hoisted_44),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (openEditModal(doc)),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 dark:text-blue-300 dark:bg-blue-950/40 dark:hover:bg-blue-900/40 border border-blue-200 dark:border-blue-800 transition",
                        title: "Edit Document Details"
                      }, [
                        _createVNode(_unref(Edit3), { class: "w-3.5 h-3.5" }),
                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "Edit", -1))
                      ], 8, _hoisted_45),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: replacingDocumentId.value === doc.document_id,
                        onClick: ($event: any) => (triggerReplaceInput(doc)),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium text-amber-700 bg-amber-50 hover:bg-amber-100 dark:text-amber-300 dark:bg-amber-950/40 dark:hover:bg-amber-900/40 border border-amber-200 dark:border-amber-800 transition disabled:cursor-not-allowed disabled:opacity-50",
                        title: "Replace Document File"
                      }, [
                        _createVNode(_unref(RefreshCw), {
                          class: _normalizeClass(["w-3.5 h-3.5", { 'animate-spin': replacingDocumentId.value === doc.document_id }])
                        }, null, 8, ["class"]),
                        _createElementVNode("span", null, _toDisplayString(replacingDocumentId.value === doc.document_id ? 'Replacing...' : 'Replace'), 1)
                      ], 8, _hoisted_46),
                      (_ctx.employee?.is_former_employee)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            disabled: archivingDocumentId.value === doc.document_id,
                            onClick: ($event: any) => (requestArchiveDocument(doc)),
                            class: "inline-flex items-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700 transition hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-50 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300 dark:hover:bg-amber-900/40",
                            title: "Move this document to the former-employee archive"
                          }, [
                            _createVNode(_unref(Archive), { class: "h-3.5 w-3.5" }),
                            _createElementVNode("span", null, _toDisplayString(archivingDocumentId.value === doc.document_id ? 'Moving...' : 'Archive'), 1)
                          ], 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (confirmDeleteDocument(doc)),
                        class: "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 dark:text-red-400 dark:bg-red-950/40 dark:hover:bg-red-900/40 border border-red-200 dark:border-red-800 transition",
                        title: "Delete Document"
                      }, [
                        _createVNode(_unref(Trash2), { class: "w-3.5 h-3.5" }),
                        _cache[35] || (_cache[35] = _createElementVNode("span", null, "Delete", -1))
                      ], 8, _hoisted_48)
                    ])
                  ])
                ], 42, _hoisted_25))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("input", {
        ref_key: "replaceFileInputRef",
        ref: replaceFileInputRef,
        type: "file",
        class: "hidden",
        accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
        onChange: handleReplaceFileSelected
      }, null, 544),
      _createVNode(BaseModal, {
        "is-visible": isEditModalVisible.value,
        title: "Edit Document Information",
        subtitle: "Update document name, category, or expiration date",
        size: "lg",
        type: "default",
        "show-footer": true,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (isEditModalVisible.value = false))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(BaseButton, {
              text: "Cancel",
              variant: "outline",
              size: "sm",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (isEditModalVisible.value = false))
            }),
            _createVNode(BaseButton, {
              text: "Save Changes",
              variant: "primary",
              size: "sm",
              loading: isSavingEdit.value,
              onClick: handleSaveEdit
            }, null, 8, ["loading"])
          ])
        ]),
        default: _withCtx(() => [
          (selectedDocForEdit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", null, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, [
                    _createTextVNode(" Document Title "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editForm.value.document_name) = $event)),
                    type: "text",
                    class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-secondary",
                    required: ""
                  }, null, 512), [
                    [_vModelText, editForm.value.document_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", null, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, [
                      _createTextVNode(" Category "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editForm.value.document_category) = $event)),
                      class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-secondary"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOCUMENT_CATEGORIES), (cat) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: cat.value,
                          value: cat.value
                        }, _toDisplayString(cat.label), 9, _hoisted_51))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, editForm.value.document_category]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Expiration Date ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editForm.value.expiry_date) = $event)),
                      type: "date",
                      class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-secondary"
                    }, null, 512), [
                      [_vModelText, editForm.value.expiry_date]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Notes / Remarks ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editForm.value.notes) = $event)),
                    rows: "2",
                    class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-secondary",
                    placeholder: "Add internal notes"
                  }, null, 512), [
                    [_vModelText, editForm.value.notes]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-visible"]),
      _createVNode(BaseModal, {
        "is-visible": isPreviewModalVisible.value,
        title: previewDoc.value?.document_name || 'Document Preview',
        subtitle: previewDoc.value ? `${previewDoc.value.file_name} (${formatFileSize(previewDoc.value.file_size)})` : 'File Preview',
        size: "4xl",
        type: "default",
        "show-footer": true,
        onClose: closePreviewModal
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_63, [
            (previewDoc.value)
              ? (_openBlock(), _createBlock(BaseButton, {
                  key: 0,
                  text: "Download",
                  variant: "outline",
                  size: "sm",
                  icon: _unref(Download),
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (downloadDocument(previewDoc.value)))
                }, null, 8, ["icon"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_64)),
            _createVNode(BaseButton, {
              text: "Close",
              variant: "primary",
              size: "sm",
              onClick: closePreviewModal
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            (isLoadingPreview.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[40] || (_cache[40] = [
                  _createElementVNode("div", { class: "w-8 h-8 border-3 border-secondary border-t-transparent rounded-full animate-spin" }, null, -1),
                  _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Loading file preview...", -1)
                ]))]))
              : (previewBlobUrl.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    (isImagePreview.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("img", {
                            src: previewBlobUrl.value,
                            alt: previewDoc.value?.document_name,
                            class: "max-w-full max-h-[580px] object-contain p-2"
                          }, null, 8, _hoisted_57)
                        ]))
                      : (isDocxPreview.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createVNode(DocxViewer, {
                              src: previewBlob.value || previewBlobUrl.value,
                              "file-name": previewDoc.value?.file_name,
                              "max-height": "600px",
                              "allow-download": false,
                              onDownload: _cache[14] || (_cache[14] = ($event: any) => (previewDoc.value ? downloadDocument(previewDoc.value) : undefined))
                            }, null, 8, ["src", "file-name"])
                          ]))
                        : (isPdfPreview.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _createElementVNode("iframe", {
                                src: previewBlobUrl.value,
                                class: "w-full h-[550px] border-none",
                                title: "PDF Preview"
                              }, null, 8, _hoisted_60)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createVNode(_unref(FileText), { class: "w-12 h-12 text-gray-400 mx-auto" }),
                              _createElementVNode("p", _hoisted_62, " Preview is not available for this file type (" + _toDisplayString(previewDoc.value?.file_name) + "). ", 1),
                              (previewDoc.value)
                                ? (_openBlock(), _createBlock(BaseButton, {
                                    key: 0,
                                    text: "Download to View",
                                    variant: "primary",
                                    size: "sm",
                                    icon: _unref(Download),
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (downloadDocument(previewDoc.value)))
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ]))
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["is-visible", "title", "subtitle"]),
      _createVNode(BaseModal, {
        "is-visible": isArchiveConfirmVisible.value,
        title: "Move Document to Archive",
        subtitle: "Confirm archive action",
        icon: _unref(Archive),
        size: "md",
        type: "warning",
        "show-footer": true,
        onClose: closeArchiveConfirmation
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_68, [
            _createVNode(BaseButton, {
              text: "Cancel",
              variant: "outline",
              size: "sm",
              disabled: Boolean(archivingDocumentId.value),
              onClick: closeArchiveConfirmation
            }, null, 8, ["disabled"]),
            _createVNode(BaseButton, {
              text: "Move to Archive",
              variant: "warning",
              size: "sm",
              icon: _unref(Archive),
              loading: Boolean(archivingDocumentId.value),
              onClick: archiveDocument
            }, null, 8, ["icon", "loading"])
          ])
        ]),
        default: _withCtx(() => [
          (documentToArchive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("p", _hoisted_66, [
                  _cache[41] || (_cache[41] = _createTextVNode(" Move ", -1)),
                  _createElementVNode("span", _hoisted_67, "\"" + _toDisplayString(documentToArchive.value.document_name) + "\"", 1),
                  _cache[42] || (_cache[42] = _createTextVNode(" to the former-employee archive? ", -1))
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-xs text-amber-700 dark:text-amber-300" }, " This document will be removed from the current employee documents and stored under Former Employee Records. ", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-visible", "icon"]),
      _createVNode(BaseModal, {
        "is-visible": isRestoreConfirmVisible.value,
        title: "Move File to Current Documents",
        subtitle: "Confirm restore action",
        icon: _unref(Undo2),
        size: "md",
        type: "warning",
        "show-footer": true,
        onClose: closeRestoreConfirmation
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_72, [
            _createVNode(BaseButton, {
              text: "Cancel",
              variant: "outline",
              size: "sm",
              disabled: isRestoring.value,
              onClick: closeRestoreConfirmation
            }, null, 8, ["disabled"]),
            _createVNode(BaseButton, {
              text: "Move to Current",
              variant: "warning",
              size: "sm",
              icon: _unref(Undo2),
              loading: isRestoring.value,
              onClick: restoreFormerFile
            }, null, 8, ["icon", "loading"])
          ])
        ]),
        default: _withCtx(() => [
          (fileToRestore.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("p", _hoisted_70, [
                  _cache[44] || (_cache[44] = _createTextVNode(" Move ", -1)),
                  _createElementVNode("span", _hoisted_71, "\"" + _toDisplayString(fileToRestore.value.file_name) + "\"", 1),
                  _cache[45] || (_cache[45] = _createTextVNode(" back to current documents? ", -1))
                ]),
                _cache[46] || (_cache[46] = _createElementVNode("p", { class: "text-xs text-amber-700 dark:text-amber-300" }, "The file will be removed from the former-employee archive and restored to the current document list.", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-visible", "icon"]),
      _createVNode(BaseModal, {
        "is-visible": isDeleteModalVisible.value,
        title: "Delete Document",
        subtitle: "Confirm deletion",
        size: "md",
        type: "danger",
        "show-footer": true,
        onClose: _cache[18] || (_cache[18] = ($event: any) => (isDeleteModalVisible.value = false))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(BaseButton, {
              text: "Cancel",
              variant: "outline",
              size: "sm",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (isDeleteModalVisible.value = false))
            }),
            _createVNode(BaseButton, {
              text: "Delete Document",
              variant: "danger",
              size: "sm",
              loading: isDeleting.value,
              onClick: handleDeleteDocument
            }, null, 8, ["loading"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("p", _hoisted_74, [
              _cache[47] || (_cache[47] = _createTextVNode(" Are you sure you want to delete ", -1)),
              _createElementVNode("span", _hoisted_75, "\"" + _toDisplayString(docToDelete.value?.document_name) + "\"", 1),
              _cache[48] || (_cache[48] = _createTextVNode("? ", -1))
            ]),
            _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-xs text-red-600 dark:text-red-400" }, " This will permanently remove the uploaded file from the server. This action cannot be undone. ", -1))
          ])
        ]),
        _: 1
      }, 8, ["is-visible"])
    ]),
    _: 1
  }, 8, ["is-visible", "subtitle", "icon"]))
}
}

})